import Agency from './Models/Agency'
import Promotion from './Models/Promotion'

Vue.prototype.$models.$agency = new Vue(Agency)
Vue.prototype.$models.$promotion = new Vue(Promotion)

Vue.component('agencies-table', () => import(/* webpackChunkName: "agencies-table" */ '@modulesPages/Site/Resources/assets/js/Tables/AgenciesTable'))
Vue.component('promotions-table', () => import(/* webpackChunkName: "promotions-table" */ '@modulesPages/Site/Resources/assets/js/Tables/PromotionsTable'))

Vue.component('agencies-form', () => import(/* webpackChunkName: "agencies-form" */ '@modulesPages/Site/Resources/assets/js/Forms/Agencies/AgenciesForm'))
Vue.component('promotions-form', () => import(/* webpackChunkName: "promotions-form" */ '@modulesPages/Site/Resources/assets/js/Forms/Promotions/PromotionsForm'))

app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
		'Modules\\Site\\Entities\\Agency': 'Agencia',
        'Modules\\Site\\Entities\\Promotion': 'Promoción'
    }   
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\Site\\Entities\\Agency': 'agencies',
		'Modules\\Site\\Entities\\Promotion': 'promotions'
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'agencies': 'Modules\\Site\\Entities\\Agency',
		'promotions': 'Modules\\Site\\Entities\\Promotion'
	}	
}